var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var dndDialogModifier = function (offsetX, offsetY) {
  return function (_a) {
    var transform = _a.transform;
    return __assign(__assign({}, transform), {
      x: transform.x - offsetX,
      y: transform.y - offsetY
    });
  };
};